var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6994_81254)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 52,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 51.5,
    stroke: "#1B9075"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6994_81254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9979 90C93.3824 90 94.7358 89.5895 95.8869 88.8203C97.038 88.0511 97.9352 86.9579 98.4651 85.6788C98.9949 84.3997 99.1335 82.9922 98.8634 81.6344C98.5933 80.2765 97.9266 79.0292 96.9477 78.0503C95.9687 77.0713 94.7214 76.4046 93.3635 76.1345C92.0057 75.8644 90.5982 76.003 89.3191 76.5328C88.04 77.0627 86.9468 77.9599 86.1776 79.111C85.4084 80.2622 84.9979 81.6155 84.9979 83C84.9979 84.8565 85.7354 86.637 87.0482 87.9497C88.3609 89.2625 90.1414 90 91.9979 90ZM91.9979 79.5C92.6901 79.5 93.3668 79.7053 93.9424 80.0899C94.518 80.4744 94.9666 81.0211 95.2315 81.6606C95.4964 82.3001 95.5657 83.0039 95.4307 83.6828C95.2956 84.3618 94.9623 84.9854 94.4728 85.4749C93.9833 85.9644 93.3597 86.2977 92.6807 86.4328C92.0018 86.5678 91.2981 86.4985 90.6585 86.2336C90.019 85.9687 89.4723 85.5201 89.0878 84.9445C88.7032 84.3689 88.4979 83.6922 88.4979 83C88.4979 82.0717 88.8667 81.1815 89.523 80.5251C90.1794 79.8687 91.0696 79.5 91.9979 79.5ZM107.153 85.0247L105.895 84.6065C106.121 82.6464 105.931 80.6605 105.336 78.7792C104.741 76.8978 103.755 75.1634 102.443 73.6898C101.131 72.2162 99.5217 71.0366 97.7217 70.2283C95.9216 69.4201 93.9711 69.0015 91.9979 69C89.999 69.0008 88.0234 69.43 86.2044 70.2587C84.3853 71.0874 82.765 72.2963 81.4526 73.8041C80.1402 75.3118 79.1662 77.0833 78.5962 78.9993C78.0263 80.9152 77.8736 82.9311 78.1484 84.911C76.4737 85.2233 74.9251 86.0134 73.6894 87.186C72.834 87.9993 72.1539 88.979 71.691 90.0648C71.2282 91.1506 70.9923 92.3197 70.9979 93.5V100.631C71.0016 102.524 71.617 104.364 72.7524 105.878C73.8878 107.392 75.4823 108.498 77.2979 109.031L82.3204 110.606C83.164 110.869 84.0426 111.002 84.9262 111C85.7276 110.999 86.5253 110.889 87.2974 110.674L97.4124 107.682C98.3135 107.436 99.264 107.436 100.165 107.682L104.342 109.082C105.372 109.333 106.445 109.346 107.48 109.122C108.516 108.897 109.487 108.441 110.32 107.787C111.154 107.132 111.828 106.297 112.292 105.345C112.756 104.392 112.997 103.346 112.998 102.287V93.276C112.994 91.4655 112.43 89.7005 111.384 88.223C110.337 86.7454 108.859 85.6277 107.153 85.023V85.0247ZM84.5744 75.5835C85.5479 74.6061 86.7047 73.8306 87.9786 73.3014C89.2526 72.7722 90.6184 72.4998 91.9979 72.4998C93.3774 72.4998 94.7432 72.7722 96.0172 73.3014C97.2911 73.8306 98.448 74.6061 99.4214 75.5835C101.385 77.5595 102.489 80.2312 102.493 83.017C102.496 85.8029 101.399 88.4774 99.4407 90.4585L93.2229 96.5048C92.8984 96.8229 92.462 97.0012 92.0075 97.0012C91.553 97.0012 91.1167 96.8229 90.7922 96.5048L84.5744 90.4848C82.6065 88.5044 81.5019 85.826 81.5019 83.0341C81.5019 80.2423 82.6065 77.5638 84.5744 75.5835ZM109.498 102.287C109.499 102.817 109.379 103.34 109.147 103.817C108.916 104.294 108.578 104.711 108.161 105.038C107.766 105.355 107.307 105.581 106.815 105.701C106.323 105.82 105.811 105.83 105.315 105.729L101.212 104.35C99.6594 103.904 98.0143 103.894 96.4569 104.322L86.3349 107.311C85.3624 107.579 84.3332 107.562 83.3704 107.26L78.3059 105.685C77.2098 105.368 76.2461 104.704 75.5594 103.793C74.8728 102.882 74.5003 101.772 74.4979 100.631V93.5C74.494 92.7926 74.6348 92.0919 74.9116 91.441C75.1885 90.79 75.5956 90.2026 76.1079 89.7148C76.9099 88.9505 77.9314 88.4571 79.0287 88.3043C79.7341 90.0528 80.7846 91.6413 82.1174 92.975L88.3597 99.0178C89.3353 99.9731 90.6464 100.508 92.0119 100.508C93.3774 100.508 94.6885 99.9731 95.6642 99.0178L101.899 92.9575C103.295 91.5558 104.377 89.8729 105.072 88.0208L106.012 88.3323C107.031 88.6974 107.913 89.3682 108.537 90.2529C109.16 91.1377 109.496 92.1934 109.498 93.276V102.287Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6994_81254",
    x: 0,
    y: 0,
    width: 184,
    height: 184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6994_81254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6994_81254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6994_81254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(71 69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.434a1ce0adc55ea0e271f85240a5141c.svg";
export { ForwardRef as ReactComponent };